/** @format */
import { Injectable } from '@angular/core';
import { ValidatablePlan } from 'common-typescript';
import { CourseUnit, Module } from 'common-typescript/types';
import { ModuleDescendantService } from './module-descendant.service';

@Injectable()
export class UntimedCourseUnitService {
    constructor(private readonly _moduleDescendantService: ModuleDescendantService) {}

    /**
     * Returns course units that are untimed and unattained but selected in the given plan under the given module.
     * If a course unit is substituted, the substituting course unit is returned instead.
     */
    getUntimedCourseUnitsForModuleRecursively(module: Module, validatablePlan: ValidatablePlan): Set<CourseUnit> {
        return new Set<CourseUnit>(
            this._moduleDescendantService
                .getCourseUnitsForModuleRecursively(module, validatablePlan)
                .values()
                .filter(
                    courseUnit => !validatablePlan.isCourseUnitAttained(courseUnit.id) && !validatablePlan.isCourseUnitTimed(courseUnit.id),
                )
                .toArray(),
        );
    }
}
